export const formatCurrency = (amount: number, currency: string = 'USD'): string =>
  new Intl.NumberFormat('en-US', { style: 'currency', currency, maximumFractionDigits: 0 }).format(amount);

export const timeAgo = (dateStr: string): string => {
  const diff = Date.now() - new Date(dateStr).getTime();
  const days = Math.floor(diff / 86400000);
  if (days === 0) return 'Today';
  if (days === 1) return '1 day ago';
  if (days < 30) return `${days} days ago`;
  return `${Math.floor(days / 30)}mo ago`;
};

export const getStatusColor = (status: string): string => {
  const colors: Record<string, string> = {
    submitted: '#2196f3',
    reviewing: '#ff9800',
    interviewing: '#9c27b0',
    hired: '#4caf50',
    rejected: '#f44336',
    bounty_paid: '#00c853',
  };
  return colors[status] || '#888';
};
